export enum ShowType {
    all = 1,
    noDate = 2,
    noDateAndMonth = 3,
    selectWeek = 4
}
